import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {
    isEmptyVariable, isAlphaNumericCharacter, getLocalStorageVariables,
    handleTokenExpiry,
    getOnlyFileNameFromPath,
    isEmptyArray,
    truncateString,
    validateFile,} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import RegularDropdown from '../../../common/DropdownMenus/RegularDropdown';
import {AddNewButtonLayout, DialogProceedButton, DialogSaveButton, TableIcon, UploadSampleLayout} from '../../../common/Global/globalStyles.style';
import * as TemplateConstants from "../../../common/Global/templateConstants";
import DatePickerComponent from "../../Tasks/Common/dateSelectComponent";
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import moment from "moment";
import { DatePicker } from 'antd';
import TableDropDown from '../../../common/DropdownMenus/TableDropdown';
import AlertDialog from '../../../common/AlertDialog';
let userDetails = getLocalStorageVariables();

class AddFieldDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,
            formErrors:{},
            showAlertDialog:false,
            showDialog:false,
            nextFollowUpDate:"",
            followUpTemplateValue:{},
            templateValues:[],
            supportingSelectedFiles:[],
            supportingRemarksArray:[],
            supportingUpdateRemarkArray:[],
            isDelete:false,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showFollowUpTemplateValueDialog){
            if(this.props.isEdit){
                let tempTemplateValues = {};
                this.props.value.map(item => {
                    tempTemplateValues[item.fieldId] = item.value
                })

                let tempTemplateValueArr = []
                let tempTemplateValue = {};
                this.props.value.forEach(item => {
                    tempTemplateValue = {
                        templateValueId:item.templateValueId,
                        value:item.value
                    };
                    tempTemplateValueArr.push(tempTemplateValue)
                })
                this.setState({
                    followUpTemplateValue:tempTemplateValues,
                    templateValues:tempTemplateValueArr
                })
            }
            this.setState({
                supportingSelectedFiles:[],
                supportingRemarksArray:[],
                supportingUpdateRemarkArray:[],
                isDelete:false
            })
        }
    }

    handleFollowUpTemplateValueDialogClose = () =>{
        this.props.handleFollowUpTemplateValueDialogClose(false);
        this.setState({
            followUpTemplateValue:{}
        })
    }

    handleFollowUpDateDialogClose = () => {
        this.setState({
            showAlertDialog:false,
            nextFollowUpDate:""
        })
    }

    handleEdit = (value,fieldItemId) => {
        let templateValueId = "";
        this.props.value.map(item => {
            if(item.fieldId == fieldItemId){
                templateValueId = item.templateValueId;
            }
        });

        if(this.props.isEdit){
            let tempTemplateValueArr = [];
            tempTemplateValueArr = this.state.templateValues.map(item => {
                if(item.templateValueId === templateValueId){
                    item.value = value
                }
                return item;
            })
            this.setState({
                templateValues:tempTemplateValueArr
            })
        }
    }
    
    handleChange = (e,fieldItem) => {
        let fieldItemId = JSON.parse(fieldItem.fieldId);

        if(this.props.isEdit){
            this.handleEdit(e.target.value,fieldItemId)
        }

        this.setState({
            followUpTemplateValue:{
                ...this.state.followUpTemplateValue,
                [fieldItemId]:e.target.value,
            }
        })
    }

    onExecuteDateFieldChange = (dateValue, fieldItem) => {
        let fieldItemId = JSON.parse(fieldItem.fieldId);

        if(this.props.isEdit){
            this.handleEdit(dateValue,fieldItemId)
        }

        this.setState({
            followUpTemplateValue:{
                ...this.state.followUpTemplateValue,
                [fieldItemId]:dateValue,
            }
        })
    };

    onNextFollowUpDateChange = (date) => {
		this.setState({
            nextFollowUpDate:isEmptyVariable(date)?"":date.format("YYYY-MM-DD"),
        })
    }

    onDropDownItemClick = (item,fieldItem) => {
        let fieldItemId = JSON.parse(fieldItem.fieldId);

        if(this.props.isEdit){
            this.handleEdit(item.value,fieldItemId)
        }

        this.setState({
            followUpTemplateValue:{
                ...this.state.followUpTemplateValue,
                [fieldItemId]:item.value,
            }
        })
    }

    addMultiSelectDropdownChange = (item,fieldItem) => {
        let fieldItemId = JSON.parse(fieldItem.fieldId);
        let multiSelectArray = [];
        if(!this.state.followUpTemplateValue[fieldItemId]){
            multiSelectArray.push(item.itemData.value)
        }else{
            multiSelectArray = JSON.parse(this.state.followUpTemplateValue[fieldItemId]);
            multiSelectArray.push(item.itemData.value)
        }
        if(this.props.isEdit){
            this.handleEdit(JSON.stringify(multiSelectArray),fieldItemId)
        }
        this.setState({
            followUpTemplateValue:{
                ...this.state.followUpTemplateValue,
                [fieldItemId]:JSON.stringify(multiSelectArray),
            }
        })
    }

    removeMultiSelectDropdownValue = (item,fieldItem) => {
        let fieldItemId = JSON.parse(fieldItem.fieldId);
        let multiSelectArray = JSON.parse(this.state.followUpTemplateValue[fieldItemId]);

        multiSelectArray = multiSelectArray.filter(i => i != item.itemData.value);
        if(this.props.isEdit){
            this.handleEdit(JSON.stringify(multiSelectArray),fieldItemId)
        }
        this.setState({
            followUpTemplateValue:{
                ...this.state.followUpTemplateValue,
                [fieldItemId]:JSON.stringify(multiSelectArray),
            }
        })
    }

    getExecTaskDisplayTableData = (assignmentTaskId,fieldItem,index) => { 
        let fields = {text:"value",value:"value"};
        let fieldsWithDesc = {text:"valueNdesc",value:"value"};
        let isFieldIdCheck = isEmptyVariable(this.state.followUpTemplateValue[fieldItem.fieldId]);
        let fieldIdValue = this.state.followUpTemplateValue[fieldItem.fieldId];
        
        switch (fieldItem.fieldType) { 
            case TemplateConstants.FIELD_TYPE_TEXT:
                return (
                    <div class="addnew-modal-form-group">
                        <p>
                            {
                                fieldItem.fieldName}{fieldItem.isMandatorySelected === "Y"?"*":""
                            }
                        </p>
                        <input type="text" 
                            placeholder={fieldItem.placeholderValue}
                            name="fieldName" 
                            value={isFieldIdCheck&&!this.props.isEdit?"":fieldIdValue} 
                            onChange={e=>this.handleChange(e,fieldItem)}
                        />
                        {
                            fieldItem.isMandatorySelected==="Y"?(!isEmptyVariable(this.state.formErrors[fieldItem.fieldId]) &&
                            <span class="cm-error">{this.state.formErrors[fieldItem.fieldId]}</span>):""
                        }
                    </div>
                );
            case TemplateConstants.FIELD_TYPE_DATE:
                return (
                    <div class="addnew-modal-form-group">
                         <p>{fieldItem.fieldName}{fieldItem.isMandatorySelected === "Y"?"*":""}</p>
                        <DatePickerComponent
                            templateItemIndex={assignmentTaskId}
                            fieldItem={fieldItem}
                            format={"DD/MM/YYYY"}
                            onDateChange={(date) => this.onExecuteDateFieldChange(date,fieldItem)}
                            placeholderValue={fieldItem.placeholderValue}
                            fieldValue={isFieldIdCheck&&!this.props.isEdit?"":fieldIdValue}
                        />
                        {
                            fieldItem.isMandatorySelected==="Y"?(!isEmptyVariable(this.state.formErrors[fieldItem.fieldId]) &&
                            <span class="cm-error">{this.state.formErrors[fieldItem.fieldId]}</span>):""
                        }
                    </div>
                );
            case TemplateConstants.FIELD_TYPE_DROPDOWN:
                return(
                    <div class="addnew-modal-form-group">
                        <p>{fieldItem.fieldName}{fieldItem.isMandatorySelected === "Y"?"*":""}</p>
                        <RegularDropdown 
                            placeholder={isFieldIdCheck&&!this.props.isEdit?fieldItem.placeholderValue:fieldIdValue}
                            dropdownArr={fieldItem.dropdownValues}
                            labelParam="value"
                            onDropDownItemClick={(item)=>this.onDropDownItemClick(item,fieldItem)}
                            defaultPlaceholderDropDown={fieldItem.placeholderValue}
                        />  
                        {
                            fieldItem.isMandatorySelected==="Y"?(!isEmptyVariable(this.state.formErrors[fieldItem.fieldId]) &&
                            <span class="cm-error">{this.state.formErrors[fieldItem.fieldId]}</span>):""
                        }
                    </div>
                );
            case TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI:
                return(
                    <div class="addnew-modal-form-group">
                        <p>{fieldItem.fieldName}{fieldItem.isMandatorySelected === "Y"?"*":""}</p>
                        <MultiSelectComponent 
                            id={"multi"+index}
                            dataSource={fieldItem.dropdownValues}
                            fields={fieldItem.showDescription === "Y"?fieldsWithDesc:fields}
                            placeholder={fieldItem.placeholderValue} 
                            mode="CheckBox"
                            select={(item)=>this.addMultiSelectDropdownChange(item,fieldItem)}
                            removed={(item)=>this.removeMultiSelectDropdownValue(item,fieldItem)}
                            closePopupOnSelect={false}
                            allowFiltering={false}
                            readOnly={true}
                            cssClass="clientsChecklist dialogcl"
                            showDropDownIcon={true}
                            showClearButton={true}
                          >
                          <Inject services={[CheckBoxSelection]} />
                          </MultiSelectComponent>
                          {
                            fieldItem.isMandatorySelected==="Y"?(!isEmptyVariable(this.state.formErrors[fieldItem.fieldId]) &&
                            <span class="cm-error">{this.state.formErrors[fieldItem.fieldId]}</span>):""
                        }
                    </div>
                );
        }
    };

    handleAlertDialogCloseInfo = () =>{
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    downloadAttachment = (documentPath,e) => {
        e.stopPropagation();
        fetch(Constants.API_SERVER_PATH+documentPath)
        .then(response => {
            return response.blob();
        })
        .then(blob => {
            let fileName = getOnlyFileNameFromPath(documentPath);
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }

    onTableDropDownItemClick = (item, dropdownItem) => {
        let arr = dropdownItem.split(":-:");
        if(item.label === "Delete"){
            this.setState({
                operationType:item.label,
                alertDialogHeading:"Delete Backup",
                proceedBtnLabel:"Delete",
                followUpBackupId:arr[2],
                showDialog:true,
                alertDialogMessage:"Are you sure you want to delete backup "+getOnlyFileNameFromPath(arr[1])+"?"
            })
        }
    }

    handleAlertDialogClose = () => {
		this.setState({
			operationType:"",
			alertDialogHeading:"",
			proceedBtnLabel:"",
			deleteReactivateId:"",
			showDialog:false,
			alertDialogMessage:""
		})
    }

    handleSupportingOnChange = (e, index) => {
        const updatedArray = [...this.state.supportingRemarksArray];
        updatedArray[index].remark = e.target.value;
        this.setState({ supportingRemarksArray: updatedArray });
    }

    onChangeSupporting = async (e) => {
        e.preventDefault();

        const input = e.target;
        const file = input.files?.[0]; // Save the file immediately
        if (!file) return;
        const result = await validateFile(file);
        if(!isEmptyVariable(file)){
            if (!result.valid) {
                this.setState({
                    showLoader: false,
                    showAlertDialogInfo: true,
                    alertDialogMessageInfo: result.message
                });
                return;
            }else{
                const formData = new FormData();
                formData.append('documentSample',file);
                formData.append('email',userDetails.email);
                formData.append('accessToken',userDetails.accessToken);

                fetch(Constants.UploadFollowUpBackup,
                {
                    method: "POST",
                    mode: 'cors',
                    body: formData
                })
                .then(response => { return response.json(); })
                .then(data => {
                    if(handleTokenExpiry(data.responseCode)) return;
                    else if(data.responseCode === Constants.CODE_SUCCESS){
                        // for (let i = 0; i < e.target.files.length; i++){
                        this.state.supportingRemarksArray.push({ fileName: data.fileName, remark: "" });
                        this.setState({
                            supportingSelectedFiles: [...this.state.supportingSelectedFiles, file]
                        })
                        // }
                    }else{
                        this.setState({
                            showAlertDialogInfo:true,
                            alertDialogMessageInfo:data.responseMessage
                        });
                    }
                });
            }
        }
    }

    handleDeleteItemClick = (index) => {
        let supportingSelectedFilesTemp = [...this.state.supportingSelectedFiles];
        supportingSelectedFilesTemp.splice(index,1);

        let remarkArr = [...this.state.supportingRemarksArray];
        remarkArr.splice(index, 1);

        this.setState({
            supportingRemarksArray:remarkArr,
            supportingSelectedFiles:supportingSelectedFilesTemp
        })
    }

    handleTemplateValueField = () => {
        let isError = false;
        let FormErrorsTemp = {};
        
        this.props.followUpTaskTemplateList.map(item => {
            let fieldValue = this.state.followUpTemplateValue[item.fieldId];
            if(item.isMandatorySelected==="Y"){
                switch (item.fieldType) { 
                    case TemplateConstants.FIELD_TYPE_TEXT:
                        if(isEmptyVariable(fieldValue)){
                            isError = true;
                            FormErrorsTemp[item.fieldId] = "Please enter Field name";
                        }
                        if(!isEmptyVariable(fieldValue)){
                            if(!isAlphaNumericCharacter(fieldValue)){
                                isError = true;
                                FormErrorsTemp[item.fieldId] = "Field name should be Alphanumeric";
                            }
                        }
                    case TemplateConstants.FIELD_TYPE_DATE:
                        if(isEmptyVariable(fieldValue)){
                            isError = true;
                            FormErrorsTemp[item.fieldId] = "Please select a date";
                        }
                    case TemplateConstants.FIELD_TYPE_DROPDOWN:
                        if(isEmptyVariable(fieldValue)){
                            isError = true;
                            FormErrorsTemp[item.fieldId] = "Please select a value";
                        }
                    case TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI:
                        if(isEmptyVariable(fieldValue)){
                            isError = true;
                            FormErrorsTemp[item.fieldId] = "Please select a value";
                        }
                }
           }
        })       

        if(isError){
            this.setState({
                formErrors:FormErrorsTemp,
                showLoader:false
            });

            setTimeout(() => {
                this.setState({
                    formErrors:{},
                });
            },Constants.WRNG_MSG_TIMEOUT);
        }else{
            if(this.props.selectFollowUpTemplate==="Checked & Open"){
                this.setState({
                    showAlertDialog:true,
                })
            }else{
                this.setState({
                    showAlertDialog: false,
                });
                if(this.props.isEdit){
                    this.EditFollowUpTaskTemplateValues();
                }else{
                    this.MarkFollowUpTaskComplete();
                }
            }
        }
    }

    handleProceedButtonClick = () => {
        let isError = false;
        if(isEmptyVariable(this.state.nextFollowUpDate)){
            isError = true;
        }
        if(isError){
            this.setState({
                errorMsg:"Please select a date",
                showLoader:false
            });

            setTimeout(() => {
                this.setState({
                    formErrors:{},
                });
            },Constants.WRNG_MSG_TIMEOUT);
        }else{
            this.setState({
                showAlertDialog: false,
            })
            this.SaveFollowUpTaskTemplateValues();
        }
    }
    /*******************API CALLS*******************/

    SaveFollowUpTaskTemplateValues = () => {
        this.setState({
            showLoader: true,
        });
        let url = "";
        
        let postParam = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            ...this.state.followUpTemplateValue,
            nextFollowUpDate:this.props.selectFollowUpTemplate==="Checked & Open"?this.state.nextFollowUpDate:""
        };

        if(!isEmptyVariable(this.props.observationId)){
            url = Constants.SaveFollowUpObservationTemplateValues
            postParam.observationId = this.props.observationId;
        }else{
            url = Constants.SaveFollowUpTaskTemplateValues
            postParam.assignmentTaskId = this.props.assignmentTaskId;
        }
        const filteredUpdatedRemark = this.state.supportingUpdateRemarkArray.filter(item => item.remark !== "" || item.responseSupportingMapId !== "");

        const remarks = [...this.state.supportingRemarksArray, ...filteredUpdatedRemark];
        postParam.remarks = JSON.stringify(remarks);
        fetch(url, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams(postParam),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                // this.handleUpdateCloseOpenStatus();
                this.props.handleFollowUpTemplateValueDialogClose(true);

                this.setState({
                    showLoader: false,
                    followUpTemplateValue:{},
                    nextFollowUpDate:""
                })  
            } else {
                this.setState({
                    showLoader: false,
                });
            }
        });
    }

    MarkFollowUpTaskComplete = () => {
        this.setState({
            showLoader:true
        })
        let url = "";
        let postParam = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            ...this.state.followUpTemplateValue,
            nextFollowUpDate:this.props.selectFollowUpTemplate==="Checked & Open"?this.state.nextFollowUpDate:""
        };
        
        if(!isEmptyVariable(this.props.observationId)){
            url = Constants.MarkFollowUpObservationComplete
            postParam.observationId = this.props.observationId
        }else{
            url = Constants.MarkFollowUpTaskComplete
            postParam.assignmentTaskId = this.props.assignmentTaskId
        }

        fetch(url, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams(postParam),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                // this.handleUpdateCloseOpenStatus();
                this.props.handleFollowUpTemplateValueDialogClose(true);

                this.setState({
                    showLoader: false,
                    followUpTemplateValue:{}
                })
            } else {
                this.setState({
                    showLoader: false,
                });
            }
        });
    }

    EditFollowUpTaskTemplateValues = () => {
        this.setState({
            showLoader:true
        })
        
        let postParam = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            assignmentId:this.props.assignmentId,
            templateValues:JSON.stringify(this.state.templateValues)
        };  

        if(!isEmptyVariable(this.props.observationId)){
            postParam.observationId = this.props.observationId
        }else{
            postParam.assignmentTaskId = this.props.assignmentTaskId
        }

        fetch(Constants.EditFollowUpTaskTemplateValues, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams(postParam),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                this.setState({
                    showLoader: false,
                })
                this.props.handleFollowUpTemplateValueDialogClose(true);
            } else {
                this.setState({
                    showLoader: false,
                });
            }
        });
    }

    handleUpdateCloseOpenStatus = () => {
        // let placeholder = (this.props.selectFollowUpTemplate==="Checked & Open")?"Open":this.props.selectFollowUpTemplate;
        
        // let postParam = {
        //     email: userDetails.email,
        //     accessToken: userDetails.accessToken,
        //     closeOpenStatus: placeholder
        // };
        
        // if(!isEmptyVariable(this.props.observationId)){
        //     postParam.observationId = this.props.observationId
        // }else{
        //     postParam.assignmentTaskId = this.props.assignmentTaskId
        // }
        this.props.handleFollowUpTemplateValueDialogClose(false);
    }

    /*******************API CALLS END HERE*******************/

    render() {
        const delDropdownObj = {
            icon:"delete",
            label:"Delete"
        }
        let actionObjAllowEdit = [delDropdownObj];
        return(
            <>
                <Modal className="custom-dialog" show={this.props.showFollowUpTemplateValueDialog} backdrop="static">
                    <Modal.Header>
                        <h5>{this.props.title}</h5>
                        <button 
                            onClick={this.handleFollowUpTemplateValueDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div class="modal-body">
                        {this.props.followUpTaskTemplateList.map((item,index) => {
                            return this.getExecTaskDisplayTableData(this.props.assignmentTaskId,item,index);
                        })}

                        <div class="addnew-modal-form-group">
                            <p>Supporting</p>
                            <UploadSampleLayout themeSettings={this.props.themeSettings} className="col-md-4 ml-0 px-0">
                                <input name="file" 
                                    type="file"
                                    id={"id"}
                                    // multiple
                                    onChange={this.onChangeSupporting}
                                />
                                <label for={"id"}>File Upload</label>
                            </UploadSampleLayout>
                        </div>
                        {!isEmptyArray(this.state.supportingSelectedFiles) &&
                            <div className="common-tab-bg mb-3">
                                <div className="common-table" style={{width:"100%"}}>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>File Name</th>
                                                <th>Remarks</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.supportingSelectedFiles.map((item,index) => {
                                                return(
                                                    <tr>
                                                        <td>{item.name}</td>
                                                        <td>
                                                        <input
                                                            type="text"
                                                            name={`remarks.${index}.remark`}
                                                            value={this.state.supportingRemarksArray[index]?.remark}
                                                            onChange={(e) => this.handleSupportingOnChange(e, index)}
                                                            className="form-control mt-1 mb-1"
                                                            style={{height:34, fontSize:"11.7px"}}
                                                        />
                                                        </td>
                                                        <td><span className="material-icons delete-doc-row"
                                                        onClick={this.handleDeleteItemClick.bind(this,index)}>
                                                            delete
                                                        </span>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }

                        <div class="modal-close-save mt-3">
                            <div class="close-save-col">
                                {!this.props.isEdit &&
                                    <button onClick={this.handleFollowUpTemplateValueDialogClose} type="button" class="modal-close">Cancel</button>
                                }
                                <DialogSaveButton themeSettings={this.props.themeSettings} onClick={this.handleTemplateValueField} type="button">{this.props.isEdit && this.props.selectFollowUpTemplate==="Checked & Open"?"Next":"Save"}</DialogSaveButton>
                            </div>
                        </div>
                    </div>

                    <AlertDialog 
                        showAlertDialog={this.state.showAlertDialogInfo}
                        handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                        type={Constants.ALERT_TYPE_ALERT}
                        alertDialogMessage={this.state.alertDialogMessageInfo}
                        proceedBtnClick={this.handleAlertDialogCloseInfo}
                        proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                        themeSettings={this.props.themeSettings}
                    />
                    <AlertDialog
                        showAlertDialog={this.state.showDialog}
                        handleAlertDialogClose={this.handleAlertDialogClose}
                        type={
                            (this.state.operationType === "Delete")
                            ?
                            Constants.ALERT_TYPE_WARNING
                            :
                            Constants.ALERT_TYPE_INFO
                        }
                        alertDialogHeading={this.state.alertDialogHeading}
                        alertDialogMessage={this.state.alertDialogMessage}
                        proceedBtnClick={this.handleRecordOperation}
                        proceedBtnLabel={this.state.proceedBtnLabel}
                        themeSettings={this.props.themeSettings}
                    />
                </Modal>

                <Modal className="custom-dialog" show={this.state.showAlertDialog} backdrop="static">
                    <Modal.Header>
                        <h5>{"Next Follow Up Date"}</h5>
                        <button 
                            onClick={this.handleFollowUpDateDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <div class="modal-body">
                        <div class="addnew-modal-form-group">
                            <DatePicker
                                onChange={this.onNextFollowUpDateChange}
                                defaultValue={!isEmptyVariable(this.state.nextFollowUpDate)?moment(this.state.nextFollowUpDate):""}
                                format={"DD/MM/YYYY"}
                                placeholder="Select Date"
                                disabledDate={(current) => current.isBefore(moment().subtract(1,"day"))}
                                selectedItem={!isEmptyVariable(this.state.nextFollowUpDate)?moment(this.state.nextFollowUpDate):""}
                            />
                        </div>
                        {
                            this.state.errorMsg &&
                            <span className="cm-error dialog-error">{this.state.errorMsg}</span>
                        }

                        <div class="dialog-btn-layout">
                            <a class="alert-cancel" href="javascript:void(0);"
                                onClick={this.handleFollowUpDateDialogClose}
                            >Cancel</a>
                            <DialogProceedButton
                                themeSettings={this.props.themeSettings}
                                class="alert-proceed"
                                href="javascript:void(0);"
                                onClick={this.handleProceedButtonClick}
                                style={{
                                    marginLeft:"10px"
                                }}
                            >
                                {this.state.showLoader ? <div class="loader-btn mt-2"></div> : "Save"}
                            </DialogProceedButton>
                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}

export default AddFieldDialog;